module.exports = __webpack_public_path__ + "static/media/om_eyeshape_almond_grey.06790b6d.png";